import RideSolvedRequest, {
  RideSolvedRequestRailyRide,
  RideSolvedRequestRideSeqItem,
  RideSolvedRequestRideWaypoint,
  RideSolvedRequestRideWaypointGroup,
  RideSolvedRequestRideWaypointMeta,
  RideSolvedRequestRideWaypointMetaSubjectList,
  RideSolvedRequestRideWaypointMetaSubjects,
} from "../../../api/raily/ride/solved/ride-solved.request";
import RideSolvedParams, {
  RideSolvedParamsRailyRide,
  RideSolvedParamsRideSeqItem,
  RideSolvedParamsRideWaypoint,
  RideSolvedParamsRideWaypointMeta,
  RideSolvedParamsRideWaypointMetaSubjectList,
  RideSolvedParamsRideWaypointMetaSubjects,
} from "./ride-solved-params";

const createRailyRideSeqItemWaypointMetaSubject = (
  subject: RideSolvedParamsRideWaypointMetaSubjects,
): RideSolvedRequestRideWaypointMetaSubjects => {
  return {
    id: subject.id,
  };
};

const createRailyRideSeqItemWaypointMetaSubjects = (
  subjects: RideSolvedParamsRideWaypointMetaSubjects[],
): RideSolvedRequestRideWaypointMetaSubjects[] => {
  return subjects.map(createRailyRideSeqItemWaypointMetaSubject);
};

const createRailyRideSeqItemWaypointMetaSubjectList = (
  subjectList: RideSolvedParamsRideWaypointMetaSubjectList,
): RideSolvedRequestRideWaypointMetaSubjectList => {
  return {
    subjects: createRailyRideSeqItemWaypointMetaSubjects(subjectList.subjects),
  };
};

const createRailyRideSeqItemWaypointMeta = (
  meta: RideSolvedParamsRideWaypointMeta,
): RideSolvedRequestRideWaypointMeta => {
  return {
    id: meta.id,
    cargoEnter: createRailyRideSeqItemWaypointMetaSubjectList(meta.cargoEnter),
    cargoExit: createRailyRideSeqItemWaypointMetaSubjectList(meta.cargoExit),
  };
};

const createRailyRideSeqItemWaypoint = (
  waypoint: RideSolvedParamsRideWaypoint,
): RideSolvedRequestRideWaypoint => {
  return {
    lat: waypoint.lat,
    lon: waypoint.lon,
    time: waypoint.time,
    haltingTime: waypoint.haltingTime,
    displayName: waypoint.displayName,
    meta: createRailyRideSeqItemWaypointMeta(waypoint.meta),
  };
};

const createRailyRideSeqItem = (
  seqItem: RideSolvedParamsRideSeqItem,
): RideSolvedRequestRideSeqItem => {
  if ("seq" in seqItem) {
    const group: RideSolvedRequestRideWaypointGroup = {
      seq: seqItem.seq.map(createRailyRideSeqItemWaypoint),
      sequenceOrder: seqItem.sequenceOrder,
    };
    return group;
  }
  return createRailyRideSeqItemWaypoint(seqItem);
};

const createRailyRideSeq = (
  seq: RideSolvedParamsRideSeqItem[],
): RideSolvedRequestRideSeqItem[] => {
  return seq.map(createRailyRideSeqItem);
};

const createRailyRide = (
  ride: RideSolvedParamsRailyRide,
): RideSolvedRequestRailyRide => {
  return {
    seq: ride.seq,
    sequenceOrder: ride.sequenceOrder,
  };
};

const create = (params: RideSolvedParams): RideSolvedRequest => {
  return {
    nodeExclusionCollection: params.nodeExclusionCollection,
    railyRide: params.railyRide,
  };
};

const rideSolvedParamsFactory = {
  create,
};

export default rideSolvedParamsFactory;
